module.exports = __webpack_public_path__ + "img/pf.3910f57f.svg";